import { useEffect, useState } from "react";
import * as invoicesMultipointActionCreators from "../../../actions/invoicesMultipoint";
import _ from "lodash";
import { Box, Typography, Alert } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import InvoicesTable from "../Table/InvoicesTable";
import InvoicesFilter from "./InvoicesFilter";
import InvoicesPagination from "./InvoicesPagination";
import { ContentHeader } from "../../ContentHeader";
import { useParams } from "react-router-dom";
import { default as filterService } from "../services/filter";

const InvoicesMultipointContent = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const { t } = useTranslation();

  const invoices = useSelector(state => state.invoices['multipoint'].items);
  const itemsOffset = useSelector(state => state.invoices['multipoint'].itemsOffset);
  const itemsPage = useSelector(state => state.invoices['multipoint'].itemsPage);
  const loaded = useSelector(state => state.invoices['multipoint'].loaded);
  const errors = useSelector(state => state.invoices['multipoint'].errors);
  const currentFilter = useSelector((state) => state.invoices['multipoint'].currentFilter);
  const token = useSelector(state => state.auth.token);

  const [initialFilter, setInitialFilter] = useState([]);
  const [initialItemsPage, setInitialItemsPage] = useState();

  useEffect(() => {
    fetchFilterParams();
  }, []);

  useEffect(() => {  //Runs when the url parameter 'contractName' changes
    if (params?.contractName) {
      setInitialFilter([
        {
          category: { type: "autocomplete", renderText: "Contracte", searchField: "polissa_id.name" },
          value: [params?.contractName], 
          type: 'contains'
        }
      ]);
      dispatch(invoicesMultipointActionCreators.fetchInvoicesMultipoint(token, false, `('polissa_id.name', 'in', ['${params.contractName}'])`));
    } else {
      setInitialFilter([]);
      dispatch(invoicesMultipointActionCreators.fetchInvoicesMultipoint(token, false, ''));
    }
    setInitialItemsPage(null);
  }, [params?.contractName]);

  const fetchFilterParams = () => {
    dispatch(invoicesMultipointActionCreators.fetchInvoicesMultipointFilterRequest());
    filterService.fetchFieldParams({
      fields: ["addresses", "contracts", "cups", "vats"],
      type: "electricity"
    })
    .then(res => {
      dispatch(invoicesMultipointActionCreators.receiveInvoicesMultipointFilter(res));
    })
    .catch(err => {
      dispatch(invoicesMultipointActionCreators.receiveInvoicesMultipointFilter({}));
    });
  }

  const fetchData = () => {
    dispatch(invoicesMultipointActionCreators.fetchInvoicesMultipoint(token, false, currentFilter, itemsOffset, itemsPage));
  };

  const applySearchFilter = (newFilters, newItemsPage) => {
    const newItemsOffset = newItemsPage !== itemsPage ? 0 : itemsOffset;
    setInitialItemsPage(newItemsPage);
    dispatch(invoicesMultipointActionCreators.fetchInvoicesMultipoint(token, false, newFilters, newItemsOffset, newItemsPage));
  };

  const handleItemsOffset = (newOffset) => {
    dispatch(invoicesMultipointActionCreators.fetchInvoicesMultipoint(token, false, currentFilter, newOffset, itemsPage));
  };

  return (
    <>
      <ContentHeader
        title={t('common:text.invoices_view_title_multipoint')}
        addButton={false}
        refreshButton={true}
        refreshClickMethod={fetchData}
      />

      {!errors ? 
        <div>
          <Box mb={2}>
            <Typography variant={"h6"}>
              {t('common:text.invoices_contracts_chart')}
            </Typography>
          </Box>

          {/* <div style={{ marginBottom: 50 }}>
            <InvoicesChart invoices={invoices} />
          </div> */}

          {loaded && invoices?.length === 0 &&
            <Alert sx={{mb: 2}} severity="info">
              {t('common:text.invoices_view_empty_list')}
            </Alert>
          }

          <div style={{ marginBottom: 20 }}>
            <InvoicesFilter 
              initialFilters={initialFilter} 
              initialItemsPage={initialItemsPage}
              applySearchFilter={applySearchFilter}
              type='multipoint'
            />
          </div>

          <InvoicesPagination onItemsOffsetChange={handleItemsOffset} type={"multipoint"}/>

          <InvoicesTable type="multipoint" />

          <InvoicesPagination onItemsOffsetChange={handleItemsOffset} type={"multipoint"}/>

        </div>
      :
        <Alert severity="warning">{t("common:text.invoices_error_fetching")}</Alert>
      }
        
    </>
  );
}

export default InvoicesMultipointContent;
